"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { PropSync } from "vue-property-decorator";
import { DiscountCouponModel } from "@/models/DiscountCoupon.model";
import { Component, Vue } from "vue-property-decorator";
let CouponDataItem = class extends Vue {
};
__decorateClass([
  PropSync("itemData", { default: function() {
    return new DiscountCouponModel();
  } })
], CouponDataItem.prototype, "_itemData", 2);
__decorateClass([
  PropSync("active", { default: function() {
    return false;
  } })
], CouponDataItem.prototype, "_active", 2);
CouponDataItem = __decorateClass([
  Component({
    filters: {
      date(value) {
        let date = new Date(parseInt(value));
        return date.toLocaleDateString();
      },
      desc_region: function(value) {
        let itemData = value;
        return (() => {
          let regions = [];
          for (let region of itemData.regions) {
            regions.push(region.name);
          }
          return regions.join("\u3001");
        })();
      },
      desc: function(value) {
        let itemData = value;
        return [
          // ( ()=> {
          //     let regions = [];
          //     for (let region of itemData.regions){
          //         regions.push(region.name);
          //     }
          //     return regions.join("、")
          // })(),
          (() => {
            let products = [];
            for (let product of itemData.goods_specs) {
              products.push(product.name);
            }
            return products.join("\u3001");
          })(),
          (() => {
            let scenes = [];
            if (itemData.scenes === null) {
              return [];
            }
            for (let scene of itemData.scenes) {
              scenes.push(scene.name);
            }
            return scenes.join("+");
          })()
        ].join("|");
      }
    }
  })
], CouponDataItem);
export {
  CouponDataItem as default
};
